$(function () {
  $('[aria-owns^="main-nav-sub-nav-v-8-"]').on("mouseenter", function () {
    var $this = $(this);

    $(".ds-main-nav-vertical-item-indicator").addClass("tw-hidden");
    $this.find(".ds-main-nav-vertical-item-indicator").removeClass("tw-hidden");

    var targetId = $(this).attr("aria-owns");
    $('[id^="main-nav-sub-nav-v-8-"]').addClass("tw-hidden");
    $("#" + targetId).removeClass("tw-hidden");
  });

  initOwlCarouselWithCustomNav();
  initOwlCarouselWithCustomNav(".ds-category-carousel", {
    margin: 32,
    loop: false,
    nav: false,
    dots: false,

    responsive: {
      0: { items: 2 },
      600: { items: 3 },
      1000: { items: 7 },
    },
  });
  initOwlCarouselWithCustomNav(".ds-banner-below-carousel", {
    margin: 16,
    loop: false,
    nav: false,
    dots: false,

    responsive: {
      0: { items: 2 },
      600: { items: 4 },
      1000: { items: 6 },
    },
  });
  initOwlCarouselWithCustomNav(".ds-brand-carousel", {
    margin: 12,
    loop: false,
    nav: false,
    dots: false,

    responsive: {
      0: { items: 2 },
      600: { items: 3 },
      1000: { items: 11 },
    },
  });
  initOwlCarouselWithCustomNav(".ds-releated-products-carousel", {
    margin: 32,
    loop: false,
    nav: false,
    dots: false,

    responsive: {
      0: { items: 2 },
      600: { items: 3 },
      1000: { items: 7 },
    },
  });
});

function initOwlCarouselWithCustomNav(parentSelector, customConfig) {
  // ES5 compatible default parameters
  parentSelector = parentSelector || ".owl--carousel";
  customConfig = customConfig || {};

  $(parentSelector).each(function () {
    var $parent = $(this);
    var $carousel = $parent.find(".ds-carousel-content");

    // Skip if carousel doesn't exist or already initialized
    if ($carousel.length === 0 || $carousel.hasClass("owl-loaded")) {
      return;
    }

    var $nextBtn = $parent.find('[data-cid="carousel-next"]');
    var $prevBtn = $parent.find('[data-cid="carousel-previous"]');

    // Default configuration
    var defaultConfig = {
      margin: 32,
      loop: false,
      nav: false,
      dots: false,

      responsive: {
        0: { items: 2 },
        600: { items: 3 },
        1000: { items: 5 },
      },
    };

    // Merge custom config with default config
    var carouselConfig = $.extend(true, {}, defaultConfig, customConfig);

    // Get total items before initializing
    var totalItems = $carousel.children().length;

    // Initialize carousel
    $carousel.owlCarousel(carouselConfig);

    // Function to disable button
    function disableButton($btn) {
      $btn
        .attr("disabled", true)
        .attr("aria-disabled", "true")
        .attr("data-disabled", "true")
        .attr("data-has-more", "false")
        .removeClass(
          "hover-active:tw-bg-ds-primary-mid tw-bg-ds-primary-off-light tw-border-ds-primary/10 tw-text-ds-primary tw-duration-300"
        )
        .addClass(
          "tw-border-transparent tw-bg-ds-button-tertiary-disabled tw-cursor-default tw-opacity-95 tw-text-ds-disabled"
        );
    }

    // Function to enable button
    function enableButton($btn) {
      $btn
        .attr("disabled", false)
        .attr("aria-disabled", "false")
        .attr("data-disabled", "false")
        .attr("data-has-more", "true")
        .removeClass(
          "tw-border-transparent tw-bg-ds-button-tertiary-disabled tw-cursor-default tw-opacity-95 tw-text-ds-disabled"
        )
        .addClass(
          "hover-active:tw-bg-ds-primary-mid tw-bg-ds-primary-off-light tw-border-ds-primary/10 tw-text-ds-primary tw-duration-300"
        );
    }

    // Function to get current items per page based on window width
    function getCurrentItemsPerPage() {
      var width = $(window).width();
      var responsive = carouselConfig.responsive;
      var itemsPerPage = 1;

      // Sort breakpoints in descending order
      var breakpoints = Object.keys(responsive)
        .map(Number)
        .sort(function (a, b) {
          return b - a;
        });

      // Find the appropriate breakpoint
      for (var i = 0; i < breakpoints.length; i++) {
        if (width >= breakpoints[i]) {
          itemsPerPage = responsive[breakpoints[i]].items;
          break;
        }
      }

      return itemsPerPage;
    }

    // Function to update button states
    function updateButtonStates() {
      var owl = $carousel.data("owl.carousel");
      if (!owl) return;

      var currentIndex = owl.current();
      var itemsCount = owl.items().length;
      var itemsPerPage = getCurrentItemsPerPage();

      // Hide buttons if items count is less than or equal to items per page
      if (itemsCount <= itemsPerPage) {
        $nextBtn.hide();
        $prevBtn.hide();
        return;
      } else {
        $nextBtn.show();
        $prevBtn.show();
      }

      // Update previous button
      if (currentIndex === 0) {
        disableButton($prevBtn);
      } else {
        enableButton($prevBtn);
      }

      // Update next button
      if (currentIndex >= itemsCount - itemsPerPage) {
        disableButton($nextBtn);
      } else {
        enableButton($nextBtn);
      }
    }

    // Function to check if buttons should be visible
    function checkButtonsVisibility() {
      var itemsPerPage = getCurrentItemsPerPage();

      if (totalItems <= itemsPerPage) {
        $nextBtn.hide();
        $prevBtn.hide();
      } else {
        $nextBtn.show();
        $prevBtn.show();
      }
    }

    // Check buttons visibility on init
    checkButtonsVisibility();

    // Wait for carousel to be fully initialized
    $carousel.on("initialized.owl.carousel", function (event) {
      updateButtonStates();
    });

    // Update on carousel events
    $carousel.on("changed.owl.carousel", function (event) {
      updateButtonStates();
    });

    // Button click handlers
    $nextBtn.off("click").on("click", function (e) {
      if ($(this).attr("disabled") === "true") {
        e.preventDefault();
        return false;
      }
      $carousel.trigger("next.owl.carousel");
    });

    $prevBtn.off("click").on("click", function (e) {
      if ($(this).attr("disabled") === "true") {
        e.preventDefault();
        return false;
      }
      $carousel.trigger("prev.owl.carousel");
    });

    // Update on window resize (debounced)
    var resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        checkButtonsVisibility();
        updateButtonStates();
      }, 250);
    });
  });
}

// Main navigation products panel toggle
(function () {
  var $button = $('[data-tid="main-nav-products-button"]');
  var $panel = $(".ds-main-nav-panel");
  var $body = $("body");
  var $panelContainer = $(".ds-main-nav-panel-container");

  var isClicked = false;
  var isHovering = false;
  var hideTimeout = null;

  function showPanel() {
    // Clear any pending hide timeout
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    $panel
      .removeClass("tw-animation-name-ds-fade-out tw-hidden")
      .addClass("tw-animation-name-ds-fade-in");
    $button
      .find(".ds-main-nav-bar-item-triggerIcon")
      .addClass("-tw-scale-y-100");
    $body.addClass("main-nav-locked").css({
      overflow: "hidden",
      "padding-right": "15px",
    });
  }

  function hidePanel() {
    // Clear any pending hide timeout
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    $panel
      .removeClass("tw-animation-name-ds-fade-in")
      .addClass("tw-animation-name-ds-fade-out");
    $button
      .find(".ds-main-nav-bar-item-triggerIcon")
      .removeClass("-tw-scale-y-100");
    $body.removeClass("main-nav-locked").css({
      overflow: "",
      "padding-right": "",
    });

    setTimeout(function () {
      $panel.addClass("tw-hidden");
    }, 300);
  }

  function scheduledHide() {
    // Only hide if not clicked and not hovering
    hideTimeout = setTimeout(function () {
      if (!isClicked && !isHovering) {
        hidePanel();
      }
      hideTimeout = null;
    }, 100);
  }

  // Click event - toggle clicked state
  $button.on("click", function (e) {
    e.preventDefault();
    isClicked = !isClicked;

    if (isClicked) {
      showPanel();
    } else {
      hidePanel();
    }
  });

  // Hover on button
  $button.on("mouseenter", function () {
    if (isClicked) return;
    isHovering = true;
    showPanel();
  });

  $button.on("mouseleave", function () {
    if (isClicked) return;
    isHovering = false;
    scheduledHide();
  });

  // Hover on panel container
  $panelContainer.on("mouseenter", function () {
    if (isClicked) return;
    isHovering = true;

    // Clear any pending hide
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
  });

  $panelContainer.on("mouseleave", function () {
    if (isClicked) return;
    isHovering = false;
    scheduledHide();
  });

  // Click outside to close when in clicked mode
  $(document).on("click", function (e) {
    if (!isClicked) return;

    if (
      !$(e.target).closest($button).length &&
      !$(e.target).closest($panelContainer).length
    ) {
      isClicked = false;
      hidePanel();
    }
  });

  // ESC key to close
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && (isClicked || isHovering)) {
      isClicked = false;
      isHovering = false;
      hidePanel();
    }
  });
})();

// Sorting
$(function () {
  var $sortingButton = $('[data-tid="order-by-select"]');
  var $sortingDropdown = $("#reka-combobox-content-v-11");
  var $svgIcon = $sortingButton
    .closest(".twpf-deep")
    .find("span > .tw-text-ds-icon-neutral");
  var isOpen = false;
  $sortingButton.on("click", function (e) {
    e.preventDefault();
    isOpen = !isOpen;

    $sortingDropdown.toggleClass("tw-hidden");
    $svgIcon.toggleClass("tw-mt-0.5 -tw-scale-y-100");

    if (isOpen) {
      // $sortingDropdown
      //   .toggleClass("tw-hidden");
      $sortingButton.attr({
        "aria-expanded": "true",
        "data-state": "open",
      });
    } else {
      // $sortingDropdown
      //   .toggleClass("tw-hidden");
      $sortingButton.attr({
        "aria-expanded": "false",
        "data-state": "closed",
      });
    }
  });
});

// Quick view product popup via AJAX with smooth animations
(function () {
  var $productDetailModal = $(".product-detail-modal");
  var $body = $("body");
  var isModalOpen = false;
  var previousUrl = null;

  // Function to show modal with animation
  function showModal(html) {
    if (!$productDetailModal.length) {
      console.error("Modal element not found");
      return;
    }

    var $content = $productDetailModal.find(".popup__content-inner");
    var $popupContent = $productDetailModal.find(".popup__content");
    var $popupBox = $productDetailModal.find(".popup__box");

    // Set content first (hidden)
    $content.html(html).css({ opacity: 0, transform: "scale(0.95)" });
    $popupBox.css({ opacity: 0, transform: "scale(0.95)" });

    // Show modal backdrop
    $productDetailModal.removeClass("tw-hidden");

    // Prevent body scroll
    $body.css({ overflow: "hidden" });
    isModalOpen = true;

    // Trigger animation after a small delay to ensure DOM is ready
    setTimeout(function () {
      // Animate backdrop fade-in
      $productDetailModal.css({
        opacity: 0,
        transition: "opacity 0.3s ease-out",
      });

      requestAnimationFrame(function () {
        $productDetailModal.css({ opacity: 1 });

        // Animate content scale and fade-in
        $popupBox.css({
          transition: "opacity 0.3s ease-out, transform 0.3s ease-out",
        });
        $content.css({
          transition:
            "opacity 0.3s ease-out 0.1s, transform 0.3s ease-out 0.1s",
        });

        requestAnimationFrame(function () {
          $popupBox.css({ opacity: 1, transform: "scale(1)" });
          $content.css({ opacity: 1, transform: "scale(1)" });
        });
      });
    }, 10);
  }

  // Function to hide modal with animation
  function hideModal() {
    if (!isModalOpen) return;

    var $popupBox = $productDetailModal.find(".popup__box");
    var $content = $productDetailModal.find(".popup__content-inner");

    // Animate content fade-out and scale-down
    $popupBox.css({
      opacity: 0,
      transform: "scale(0.95)",
      transition: "opacity 0.2s ease-in, transform 0.2s ease-in",
    });
    $content.css({
      opacity: 0,
      transform: "scale(0.95)",
      transition: "opacity 0.2s ease-in, transform 0.2s ease-in",
    });

    // Animate backdrop fade-out
    $productDetailModal.css({
      opacity: 0,
      transition: "opacity 0.2s ease-in",
    });

    // Hide modal and restore body scroll after animation
    setTimeout(function () {
      $productDetailModal.addClass("tw-hidden");
      $body.css({ overflow: "" });
      isModalOpen = false;

      // Restore previous URL
      if (previousUrl !== null) {
        window.history.replaceState({}, "", previousUrl);
        previousUrl = null;
      }

      // Reset styles for next open
      $productDetailModal.css({ opacity: "", transition: "" });
      $popupBox.css({ opacity: "", transform: "", transition: "" });
      $content.css({ opacity: "", transform: "", transition: "" });
    }, 200);
  }

  // Open modal on quick-view click
  $(document).on("click", ".quick-view", function (e) {
    e.preventDefault();

    var $btn = $(this);
    var url = $btn.attr("href");

    if (!url) {
      return;
    }

    // Save current URL before changing it
    previousUrl =
      window.location.pathname + window.location.search + window.location.hash;

    // Show loading state in modal first
    if ($productDetailModal.length) {
      var $content = $productDetailModal.find(".popup__content-inner");
      var $popupBox = $productDetailModal.find(".popup__box");

      // Set loading HTML
      $content.html(
        '<div class="tw-flex tw-items-center tw-justify-center lg:tw-pt-12 tw-pb-12"><div class="tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-b-2 tw-border-ds-primary"></div></div>'
      );

      // Show modal with loading state
      $content.css({ opacity: 1, transform: "scale(1)" });
      $popupBox.css({ opacity: 1, transform: "scale(1)" });
      $productDetailModal.removeClass("tw-hidden");
      $productDetailModal.css({
        opacity: 1,
        transition: "opacity 0.2s ease-out",
      });
      // Keep product detail visible from the top on mobile
      $content.scrollTop(0);
      $productDetailModal.find(".popup__wrap-align").scrollTop(0);
      $body.css({ overflow: "hidden" });
      isModalOpen = true;
    }

    $.ajax({
      url: url,
      type: "GET",
      data: { quick_view: 1 },
      success: function (html) {
        // Update content with fade animation
        var $content = $productDetailModal.find(".popup__content-inner");
        $content.css({ opacity: 0, transition: "opacity 0.2s ease-out" });

        setTimeout(function () {
          $content.html(html);
          $content.scrollTop(0);
          $productDetailModal.find(".popup__wrap-align").scrollTop(0);

          // Init Owl carousel
          initOwlCarouselWithCustomNav(".ds-releated-products-carousel", {
            margin: 32,
            loop: false,
            nav: false,
            dots: false,

            responsive: {
              0: { items: 2 },
              600: { items: 3 },
              1000: { items: 5 },
            },
          });

          $content.css({ opacity: 1 });
          // Update url in browser
          window.history.pushState({}, "", url);
        }, 100);
      },
      error: function () {
        console.log("Error");
        // Fallback: go to product detail page normally
        hideModal();
        previousUrl = null; // Reset previousUrl on error
        window.location.href = url;
      },
    });
  });

  // Close modal handlers
  $(document).on("click", '[data-tid="product-detail__close"]', function (e) {
    e.preventDefault();
    hideModal();
  });

  // Close on backdrop click or click outside popup__content
  $(document).on("click", ".product-detail-modal", function (e) {
    var $popupContent = $(this).find(".popup__content");
    var $clickedElement = $(e.target);

    // Don't close if clicking on quick-view link (for nested quick views)
    if ($clickedElement.closest(".quick-view").length) {
      return;
    }

    // Close if clicking on backdrop (modal itself) or outside popup__content
    if (
      $clickedElement.hasClass("product-detail-modal") ||
      (!$clickedElement.closest(".popup__content").length &&
        !$clickedElement.closest('[data-tid="product-detail__close"]').length)
    ) {
      hideModal();
    }
  });

  // Close on ESC key
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && isModalOpen) {
      hideModal();
    }
  });
})();

// Filter drawer toggle and accordion
(function () {
  var $body = $("body");
  var isDrawerOpen = false;

  // Find drawer elements
  var $drawerOverlay = $('[data-ds-dialog-overlay=""]');
  var $drawerContent = $("#reka-dialog-content-v-8");
  var $drawerCloseBtn = $('[data-tid="close-btn"]');

  // Initialize drawer as closed on page load
  $(function () {
    if ($drawerOverlay.length && $drawerContent.length) {
      $drawerOverlay.attr("data-state", "closed").attr("aria-hidden", "true");
      $drawerContent
        .attr("data-state", "closed")
        .attr("aria-expanded", "false");
      // Hide drawer initially
      $drawerOverlay.css({ display: "none" });
      $drawerContent.css({ display: "none" });
    }
  });

  // Function to show drawer with smooth animation
  function showDrawer() {
    if (isDrawerOpen || !$drawerOverlay.length || !$drawerContent.length)
      return;

    // Show drawer elements
    $drawerOverlay.css({ display: "block" });
    $drawerContent.css({ display: "flex" });

    // Set initial state
    $drawerOverlay.attr("data-state", "open").attr("aria-hidden", "false");
    $drawerContent.attr("data-state", "open").attr("aria-expanded", "true");

    // Prevent body scroll
    $body.css({ overflow: "hidden" });
    isDrawerOpen = true;

    // Trigger animation
    requestAnimationFrame(function () {
      $drawerOverlay.css({
        opacity: 0,
        transition: "opacity 0.3s ease-out",
      });
      $drawerContent.css({
        transform: "translateX(100%)",
        transition: "transform 0.3s ease-out",
      });

      requestAnimationFrame(function () {
        $drawerOverlay.css({ opacity: 1 });
        $drawerContent.css({ transform: "translateX(0)" });
      });
    });
  }

  // Function to hide drawer with smooth animation
  function hideDrawer() {
    if (!isDrawerOpen || !$drawerOverlay.length || !$drawerContent.length)
      return;

    // Animate out
    $drawerOverlay.css({
      opacity: 0,
      transition: "opacity 0.3s ease-in",
    });
    $drawerContent.css({
      transform: "translateX(100%)",
      transition: "transform 0.3s ease-in",
    });

    // Update state and restore body scroll after animation
    setTimeout(function () {
      $drawerOverlay.attr("data-state", "closed").attr("aria-hidden", "true");
      $drawerContent
        .attr("data-state", "closed")
        .attr("aria-expanded", "false");
      $body.css({ overflow: "" });
      isDrawerOpen = false;

      // Hide drawer elements
      $drawerOverlay.css({ display: "none", opacity: "", transition: "" });
      $drawerContent.css({ display: "none", transform: "", transition: "" });
    }, 300);
  }

  // Helper function to find filter button
  function getFilterButton() {
    return $("button")
      .filter(function () {
        return $(this).text().indexOf("Všechny filtry") !== -1;
      })
      .first();
  }

  // Helper function to update filter button state
  function updateFilterButtonState(state) {
    var $btn = getFilterButton();
    if ($btn.length) {
      $btn
        .attr("data-state", state)
        .attr("aria-expanded", state === "open" ? "true" : "false");
    }
  }

  // Toggle drawer on button click (button containing "Všechny filtry")
  $(document).on("click", function (e) {
    var $target = $(e.target);
    var $btn = $target.closest("button");

    if ($btn.length && $btn.find('[data-attribute="filters"]').length) {
      e.preventDefault();
      var currentState = $btn.attr("data-state");

      if (currentState === "closed" || !currentState) {
        showDrawer();
        updateFilterButtonState("open");
      } else {
        hideDrawer();
        updateFilterButtonState("closed");
      }
    }
  });

  // Close drawer on close button click
  $(document).on("click", '[data-tid="close-btn"]', function (e) {
    e.preventDefault();
    hideDrawer();
    updateFilterButtonState("closed");
  });

  // Close drawer on overlay click
  $(document).on("click", '[data-ds-dialog-overlay=""]', function (e) {
    if ($(e.target).is('[data-ds-dialog-overlay=""]')) {
      hideDrawer();
      updateFilterButtonState("closed");
    }
  });

  // Close drawer on ESC key
  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && isDrawerOpen) {
      hideDrawer();
      updateFilterButtonState("closed");
    }
  });

  // Accordion toggle for filter options
  $(document).on("click", "[data-ds-accordion-trigger]", function (e) {
    e.preventDefault();
    var $trigger = $(this);
    var $accordionItem = $trigger.closest("[data-ds-accordion-item]");
    var $content = $accordionItem.find('[role="region"]');
    var currentState = $trigger.attr("data-state");

    // Toggle state
    var newState = currentState === "open" ? "closed" : "open";

    // Update trigger attributes
    $trigger.attr("data-state", newState);
    $trigger.attr("aria-expanded", newState === "open" ? "true" : "false");
    $accordionItem.attr("data-state", newState);

    // Animate content
    if (newState === "open") {
      $content.removeAttr("hidden").css({
        maxHeight: "0",
        opacity: 0,
        transition: "max-height 0.3s ease-out, opacity 0.3s ease-out",
      });

      // Get natural height
      var height = $content[0].scrollHeight;

      requestAnimationFrame(function () {
        $content.css({
          maxHeight: height + "px",
          opacity: 1,
        });

        // Remove max-height after animation to allow content changes
        setTimeout(function () {
          $content.css({ maxHeight: "", transition: "" });
        }, 300);
      });
    } else {
      // Get current height before closing
      var height = $content[0].scrollHeight;
      $content.css({
        maxHeight: height + "px",
        opacity: 1,
        transition: "max-height 0.3s ease-in, opacity 0.3s ease-in",
      });

      requestAnimationFrame(function () {
        $content.css({
          maxHeight: "0",
          opacity: 0,
        });

        setTimeout(function () {
          $content.attr("hidden", "");
          $content.css({ maxHeight: "", transition: "" });
        }, 300);
      });
    }
  });
})();

(function () {
  // Handle attribute filtering
  $(document).on("click", "[data-attribute=product]", function (e) {
    e.preventDefault();

    var $this = $(this);
    var $button = $this.find("button");
    var $span = $button.find("span.tw-text-white");
    var isChecked = $button.attr("data-state") === "checked";

    $button.attr("data-state", isChecked ? "unchecked" : "checked");
    $button.attr("aria-checked", isChecked ? "false" : "true");

    var attributeSlug = $button.attr("data-reka-collection-item");
    var termId = $button.attr("data-term");

    if (isChecked) {
      $button
        .removeClass("tw-text-ds-form-control-accent tw-bg-current")
        .addClass("tw-bg-transparent tw-text-ds-neutral-40");
      $span.removeClass("tw-visible").addClass("tw-invisible");

      removeFromUrl(attributeSlug, termId);
    } else {
      $button
        .addClass("tw-text-ds-form-control-accent tw-bg-current")
        .removeClass("tw-bg-transparent tw-text-ds-neutral-40");
      $span.addClass("tw-visible").removeClass("tw-invisible");

      addToUrl(attributeSlug, termId);
    }
  });

  // Handle sorting
  $(document).on("click", "[data-attribute=sorting]", function (e) {
    e.preventDefault();

    var $this = $(this);
    var option = $this.attr("data-order-by-option");
    var $icon = $this.find("[data-attribute=icon]");
    var $sortingName = $this.data("name");

    $("[data-sorting-name]").text($sortingName);

    $("[data-attribute=sorting]").attr("data-state", "unchecked");
    $("[data-attribute=icon]").addClass("tw-hidden");

    $this.attr("data-state", "checked");
    $icon.removeClass("tw-hidden");

    updateSortInUrl(option);
  });

  function addToUrl(attributeSlug, termId) {
    var url = new URL(window.location);
    var params = url.searchParams;

    var paramKey = "ixwpst[" + attributeSlug + "][]";
    var currentValues = params.getAll(paramKey);

    if (!currentValues.includes(termId)) {
      currentValues.push(termId);
    }

    params.delete(paramKey);

    currentValues.forEach(function (value) {
      params.append(paramKey, value);
    });

    var decodedUrl = decodeURIComponent(url.toString());
    window.history.pushState({}, "", decodedUrl);

    // Trigger AJAX product fetch
    fetchProducts();
  }

  function removeFromUrl(attributeSlug, termId) {
    var url = new URL(window.location);
    var params = url.searchParams;

    var paramKey = "ixwpst[" + attributeSlug + "][]";
    var currentValues = params.getAll(paramKey);

    currentValues = currentValues.filter(function (value) {
      return value !== termId;
    });

    params.delete(paramKey);

    currentValues.forEach(function (value) {
      params.append(paramKey, value);
    });

    var decodedUrl = decodeURIComponent(url.toString());
    window.history.pushState({}, "", decodedUrl);

    // Trigger AJAX product fetch
    fetchProducts();
  }

  function updateSortInUrl(sortName) {
    var url = new URL(window.location);
    var params = url.searchParams;

    params.set("orderby", sortName);

    var decodedUrl = decodeURIComponent(url.toString());
    window.history.pushState({}, "", decodedUrl);

    // Trigger AJAX product fetch
    fetchProducts();
  }

  // AJAX function to fetch products based on current URL parameters
  function fetchProducts() {
    var url = new URL(window.location);
    var params = url.searchParams;

    // Build data object from URL parameters
    var data = {
      s: params.get("s") || "",
      category_id: $("#ds-category-id").data("id") || "",
      listing: $("#ds-category-id").data("listing") || "",
      brand: params.get("brand") || "",
      orderby: params.get("orderby") || "",
      page: params.get("page") || "",
      ixwpst: {},
    };

    // Extract all ixwpst filter parameters (ES5 compatible)
    params.forEach(function (value, key) {
      var match = key.match(/^ixwpst\[([^\]]+)\]\[\]$/);
      if (match) {
        var attributeSlug = match[1];
        if (!data.ixwpst[attributeSlug]) {
          data.ixwpst[attributeSlug] = [];
        }
        data.ixwpst[attributeSlug].push(value);
      }
    });
    // Show loading state
    var $productContainer = $('[data-render="products"]');
    var $pagination = $(".m-pagination");

    if ($productContainer.length) {
      $productContainer.css({ opacity: 0.5, pointerEvents: "none" });
    }

    if ($pagination.length) {
      $pagination.addClass("loading");
    }

    // Make AJAX request
    $.ajax({
      url: "/products/get-by-attributes",
      type: "POST",
      data: data,
      headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
      },
      success: function (response) {
        // Update product container with new HTML
        if ($productContainer.length && response) {
          $productContainer.html(response);
          $("[data-product-total]").text(
            $productContainer.find("[data-product-count]").text()
          );
        }

        // Restore container state
        $productContainer.css({ opacity: 1, pointerEvents: "auto" });

        // Remove loading state from pagination
        $(".m-pagination").removeClass("loading");

        // Scroll to top of product container
        $("html, body").animate(
          {
            scrollTop: $productContainer.offset().top - 100,
          },
          300
        );

        // Reinitialize any carousels or other components if needed
        // if (typeof initOwlCarouselWithCustomNav === 'function') {
        //   initOwlCarouselWithCustomNav();
        // }
      },
      error: function (xhr, status, error) {
        console.error("Error fetching products:", error);

        // Restore container state
        $productContainer.css({ opacity: 1, pointerEvents: "auto" });

        // Remove loading state from pagination
        $(".m-pagination").removeClass("loading");

        // Optionally show error message to user
      },
    });
  }

  // Handle pagination clicks
  $(document).on("click", ".pagination a", function (e) {
    e.preventDefault();

    var href = $(this).attr("href");
    if (!href) return;

    // Extract page number from URL
    var url = new URL(href);
    var pageNumber = url.searchParams.get("page");

    if (pageNumber) {
      // Update URL with page parameter
      var currentUrl = new URL(window.location);
      currentUrl.searchParams.set("page", pageNumber);

      var decodedUrl = decodeURIComponent(currentUrl.toString());
      window.history.pushState({}, "", decodedUrl);

      // Trigger AJAX product fetch
      fetchProducts();
    }
  });
})();

// Show profile nav
$(function () {
  // Only the logged-in header control (guest login link also shares this tid)
  var $button = $("#user-control-nav[data-tid='user-menu-trigger']");
  var $nav = $('[data-reka-popper-content-wrapper="profile-nav"]');
  var mobileBreakpoint = 992;

  if (!$button.length) {
    return;
  }

  function isMobile() {
    return window.innerWidth < mobileBreakpoint;
  }

  function openNav() {
    $nav.removeClass("tw-hidden");
    $button.attr("data-state", "open");
  }

  function closeNav() {
    $nav.addClass("tw-hidden");
    $button.attr("data-state", "closed");
  }

  // Mobile: pages that ship the profile sidebar are handled by CoreWeb
  // (core.js) opening userAside; everywhere else the icon opens this dropdown.
  $button.on("click", function (e) {
    if (!isMobile() || $('[data-content="userAside"]').length) {
      return;
    }

    e.preventDefault();

    if ($nav.hasClass("tw-hidden")) {
      openNav();
    } else {
      closeNav();
    }
  });

  // Desktop: toggle on hover
  $button.on("mouseenter", function () {
    if (isMobile()) {
      return;
    }
    openNav();
  });

  // Close when mouse leaves both button and nav
  var closeTimeout;
  var buttonHovered = false;
  var navHovered = false;

  $button
    .on("mouseenter", function () {
      if (isMobile()) {
        return;
      }
      buttonHovered = true;
      clearTimeout(closeTimeout);
    })
    .on("mouseleave", function () {
      if (isMobile()) {
        return;
      }
      buttonHovered = false;
      closeTimeout = setTimeout(function () {
        if (!buttonHovered && !navHovered) {
          closeNav();
        }
      }, 200);
    });

  $nav
    .on("mouseenter", function () {
      if (isMobile()) {
        return;
      }
      navHovered = true;
      clearTimeout(closeTimeout);
    })
    .on("mouseleave", function () {
      if (isMobile()) {
        return;
      }
      navHovered = false;
      closeTimeout = setTimeout(function () {
        if (!buttonHovered && !navHovered) {
          closeNav();
        }
      }, 200);
    });

  $button.add($nav).on("mouseenter", function () {
    if (isMobile()) {
      return;
    }
    clearTimeout(closeTimeout);
  });

  // Close profile dropdown when tapping outside on mobile
  $(document).on("click", function (e) {
    if (!isMobile()) {
      return;
    }
    if ($(e.target).closest('[data-tid="user-menu-trigger"], [data-reka-popper-content-wrapper="profile-nav"]').length) {
      return;
    }
    closeNav();
  });
});

$(function () {
  // Toggle sticky header on scroll
  var $header = $(".app-header");
  var $body = $("body");
  function handleHeaderSticky() {
    var isSticky = $(window).scrollTop() > 0;
    if (isSticky) {
      var headerHeight = $header.outerHeight() || 0;
      document.documentElement.style.setProperty(
        "--app-header-height",
        headerHeight + "px"
      );
    }
    $header.toggleClass("app-header--sticky", isSticky);
  }
  handleHeaderSticky();
  $(window).on("scroll", handleHeaderSticky);
});
